import React from 'react';

const CheckboxTemplate = ({ handleSingleCheckboxClick, selectedRows, rowData }) => {
  return (
    <input
      type="checkbox"
      className="d-flex mt-1"
      onChange={(e) => handleSingleCheckboxClick(e, rowData)}
      checked={selectedRows?.includes(rowData)}
    />
  );
};

export default CheckboxTemplate;
